export const ButtonStyleType = {
  Secondary: 'secondary',
  Primary: 'primary',
};
